import { useCallback } from "react";

import type { DocumentDto } from "@/api/types";
import type { FormDocument } from "@/components/DocumentInput/useDocumentInput";
import { isDocumentUploaded } from "@/components/DocumentInput/useDocumentInput";
import type { UploadDocumentRequest } from "@/queries/files/mutations";
import { fileMutations } from "@/queries/files/mutations";

export function useUploadDocument(): {
  uploadDocument: UploadDocument;
  uploadFormDocument: UploadFormDocument;
  isUploadingDocument: boolean;
} {
  const { mutateAsync: uploadDocument, isPending: isUploadingDocument } = fileMutations.useAddDocument();

  const uploadFormDocument: UploadFormDocument = useCallback(
    async (formDocument) => {
      if (isDocumentUploaded(formDocument)) {
        return formDocument;
      }

      if (formDocument.uploadPromise) {
        return formDocument.uploadPromise;
      }

      return await uploadDocument(formDocument);
    },
    [uploadDocument],
  );

  return { uploadDocument, uploadFormDocument, isUploadingDocument };
}

type UploadDocument = (image: UploadDocumentRequest) => Promise<DocumentDto>;
type UploadFormDocument = (document: FormDocument) => Promise<DocumentDto | undefined>;
